
export const convertMinutesToHours = (timeObject) => {
    const updatedTimeObject = {};
    if (timeObject === undefined) {
        return updatedTimeObject;
    }
    for (const [key, value] of Object.entries(timeObject)) {
        const hours = (value / 60).toFixed(2);
        updatedTimeObject[key] = `${hours} Hrs`;
    }
    return updatedTimeObject;
}

export const convertMinutesToHoursSorted = (timeObject) => {
    const updatedTimeObject = {};
    if (timeObject === undefined) {
        return updatedTimeObject;
    }
    
    const sortedKeys = Object.keys(timeObject).sort();
    for (const key of sortedKeys) {
        const value = timeObject[key];
        const hours = (value / 60).toFixed(2);
        updatedTimeObject[key] = `${hours} Hrs`;
    }
    return updatedTimeObject;
}

export const timePercentage = (used, quoted) => {
    const usedValue = parseFloat(used);
    const quotedValue = parseFloat(quoted);

    if (isNaN(usedValue) || isNaN(quotedValue) || quotedValue === 0) {
        return 100;
    }

    const percentage = (usedValue * 100) / quotedValue;
    if (percentage > 100)
        return 100;
    return percentage;
};

export const addUpTime = (timeObject) => {
    if (timeObject === undefined)
        return 0;
    if (Object.keys(timeObject).length === 0)
        return 0;
    let totalTime = 0;
    for (const value of Object.values(timeObject)) {
        const timeValue = parseFloat(value);
        totalTime += timeValue;
    }
    return totalTime;
}

export const formatTime = (time) => {
    const [hours, minutes] = time.split(/[:\s]/);
    return `${hours > 12 ? `${hours - 12}` : hours}${minutes ? `:${minutes}` : ':00'} ${hours > 12 ? 'PM' : 'AM'}`;
}

export const formatTime24 = (time) => {
    const [hours, minutes] = time.split(/[:\s]/);
    return `${hours}${minutes ? `:${minutes}` : ':00' }`;
}

const BILLING_TYPE_ABBR = {
    'Fixed Price': 'FP',
    'Hourly': 'H',
    'Internal': 'INT',
    'Non Billable': 'NB',
    'Retainer': 'R',
};

export const billingTypeAbbr = (type) => BILLING_TYPE_ABBR[type] || type;

export const formatMinutesAsHours = (minutes) => ((minutes || 0) / 60).toFixed(2);
